import requestAction from '../../utils/requestAction'

export const fetchCurrentAccounts = (params: string) => 
  requestAction('CURRENT_ACCOUNT_LIST', params)(`currentAccounts`, 'GET')
